import React from "react"
import {Typography} from "@mui/material"


export default function nameColumn() {
	return {
		name: "acriss_code", label: "Site",
		options: {
			headerAlign: 'left',
			customBodyRowRenderLite: value => <Typography variant="subtitle1">
				{value}
			</Typography>
		}
	}
}